import { render, staticRenderFns } from "./PFullFunctionIntroductionModal.vue?vue&type=template&id=86c51d1a&scoped=true&"
import script from "./PFullFunctionIntroductionModal.vue?vue&type=script&lang=ts&"
export * from "./PFullFunctionIntroductionModal.vue?vue&type=script&lang=ts&"
import style0 from "./PFullFunctionIntroductionModal.vue?vue&type=style&index=0&id=86c51d1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c51d1a",
  null
  
)

export default component.exports